import { Route, Switch, useRouteMatch } from 'react-router-dom'
import { DocumentsList } from './DocumentsList'
import { DocumentsUpdate } from './DocumentsUpdate'

export const Documents = () => {
  const match = useRouteMatch()

  return (
    <Switch>
      <Route path={`${match.url}/new`} exact>
        <DocumentsUpdate />
      </Route>
      <Route path={`${match.url}/edit/:id`} exact>
        <DocumentsUpdate />
      </Route>
      <Route path={`${match.url}/:params?`}>
        <DocumentsList />
      </Route>
    </Switch>
  )
}